<template>
  <div>
    <v-row>
      <v-col cols="12" sm="7" md="7" lg="6" xl="5" class="pr-4">
        <h4 class="text-left mt-1">{{ $t("home.mydata") }}</h4>
        <v-item-group>
          <v-row no-gutters>
            <v-item
              v-for="item in principalItems"
              :key="item.name"
              class="mb-4"
            >
              <v-col cols="6" sm="12" md="12" lg="6" v-if="item.isInternal === false || isInternal === true">
                <v-card
                  class="d-flex align-left pl-4 mr-2 mr-sm-0 mr-md-0 mr-lg-2 py-4"
                  :to="item.path"
                >
                  <div class="flex-grow-1 text-left">
                    <v-icon color="black" left>{{ item.icon }}</v-icon>
                    {{ $t(item.name) }}
                  </div>
                </v-card>
              </v-col>
            </v-item>
          </v-row>
          <v-item class="mb-4 mt-4">
            <PendingUserForms
              v-if="isInternal"
              :headers_2="headersTable"
              :title="$t('table.pendingForms')"
              :items="pendingForms"
            />
          </v-item>
        </v-item-group>
      </v-col>
      <v-col cols="12" sm="5" md="5" lg="6" xl="7" class="pl-4" v-if="isInternal">
        <h4 class="text-left mt-1">{{ $t("home.sendforms") }}</h4>
        <v-item-group>
          <v-row no-gutters>
            <v-item
              v-for="item in items"
              :key="item.name"
              class="mb-4"
            >
              <v-col cols="6" sm="12" md="12" lg="6">
                <v-card
                  class="d-flex align-center pl-4 mr-2 mr-sm-0 mr-md-0 mr-lg-2 py-4"
                  :to="item.path"
                  :disabled="item.disabled == true"
                >
                  <div class="flex-grow-1 text-left">
                    <v-icon color="black" left>{{ item.icon }}</v-icon>
                    {{ $t(item.name) }}
                    <v-chip
                      small
                      v-if="item.pendingForms > 0"
                      color="grey darken-1"
                      text-color="white"
                      right
                    >
                      {{ item.pendingForms }}
                    </v-chip>
                  </div>
                </v-card>
              </v-col>
            </v-item>
          </v-row>
        </v-item-group>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import axios from "axios";
import PendingUserForms from "../components/forms/PendingUserForms";
export default {
  components: { PendingUserForms },
  data() {
    return {
      headersTable: [
        { text: this.$t("name"), value: "title", width: "22%" },
        { text: this.$t("formName"), value: "form_name", width: "30%" }
      ],
      pendingForms: [],
      principalItems: [
        { name: "section.myAccount", icon: "settings", path: "/my-account", isInternal: false },
        { name: "section.general_plan", icon: "mdi-floor-plan", path: "/building", isInternal: true },
        { name: "section.indicators", icon: "mdi-chart-pie", path: "/indicators", isInternal: true },
        { name: "section.myForms", icon: "mdi-email-send", path: "/my-forms", isInternal: true }
      ],
      items: [
        {
          name: "section.investigators",
          icon: "accessibility_new",
          path: "/researchers",
          pendingForms: 0
        },
        {
          name: "section.publications",
          icon: "menu_book",
          path: "/publications",
          pendingForms: 0
        },
        {
          name: "section.projects",
          icon: "mdi-briefcase-variant",
          path: "/projects",
          pendingForms: 0,
        },
        {
          name: "section.stays",
          icon: "mdi-human-dolly",
          path: "/stays",
          pendingForms: 0,
          disabled: false
        },
        {
          name: "section.pressNews",
          icon: "mdi-newspaper-variant-multiple-outline",
          path: "/pressNews",
          pendingForms: 0
        },
        {
          name: "section.industrial_property",
          icon: "mdi-rocket-launch",
          path: "/industrial-property",
          pendingForms: 0,
          disabled: false
        },
        {
          name: "section.softwares",
          icon: "mdi-database-import",
          path: "/softwares",
          pendingForms: 0,
          disabled: false
        },
        {
          name: "section.datasets",
          icon: "mdi-database",
          path: "/datasets",
          pendingForms: 0,
          disabled: false
        }
      ]
    };
  },
  created() {
    if (this.$store.state.isInternal){
      this.getPendingUserforms();
    }
  },

  methods: {
    getPendingUserforms() {
      let path =
        this.$store.state.endpoint + "/user/moderatedOperations/pending";
      axios
        .get(path)
        .then(response => {
          this.pendingForms = response.data;
          this.items[0].pendingForms = response.data.filter(
            form => form.object_type === "investigator"
          ).length;
          this.items[1].pendingForms = response.data.filter(
                  form => form.object_type === "publication"
          ).length;
          this.items[2].pendingForms = response.data.filter(
              form => form.object_type === "project"
          ).length;
          this.items[3].pendingForms = response.data.filter(
              form => form.object_type === "stay"
          ).length;
          this.items[4].pendingForms = response.data.filter(
              form => form.object_type === "news"
          ).length;
          this.items[5].pendingForms = response.data.filter(
              form => form.object_type === "industrial_property"
          ).length;
          this.items[6].pendingForms = response.data.filter(
              form => form.object_type === "software"
          ).length;
          this.items[7].pendingForms = response.data.filter(
              form => form.object_type === "dataset"
          ).length;
        })
        .catch(error => {
          console.log(error)
        });
    }
  }
};
</script>
